import React from "react"

import "../styles/Footer.css"

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div>
          <a className="footer-copyright-text" href="http://sysout.ddns.net">
            <p>©sysout</p>
          </a>
        </div>
      </div>
    </footer>
  )
}
